module.exports = __webpack_public_path__ + "static/img/anxun12 - 副本.d7d3cd53.png";